module.exports = __webpack_public_path__ + "static/media/casino.f979e40a.svg";